import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ChatErrorState = ({
  onStartNewChat
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    gap: "400",
    padding: "300",
    children: [/*#__PURE__*/_jsx(Pictogram, {
      name: "Chat",
      size: "md"
    }), /*#__PURE__*/_jsx(Text, {
      typography: "heading-300",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.errors.loadFailedTitle"
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.errors.loadFailedBody"
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "primary",
      size: "medium",
      onClick: onStartNewChat,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.errors.startNewChat"
      })
    })]
  });
};